// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root___xWu0","inputWrap":"CustomTip_inputWrap__3P0u0"};